import React from 'react';
import { Link } from 'react-router-dom';

export const HomePage: React.FC = () => {
  return (
    <div>
      {/* Hero */}
      <section
        className="text-white text-center py-24 px-4"
        style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}
      >
        <h1 className="text-3xl sm:text-5xl font-light mb-5">Find Your Practice, Find Your People</h1>
        <p className="text-xl mb-8 max-w-xl mx-auto opacity-90">
          The mat is solitary. The room isn't. Connect with teachers and fellow practitioners at parks,
          beaches, and unexpected places — and searching for a class is always free.
        </p>
        <Link
          to="/events"
          className="inline-block bg-green-800 hover:bg-green-900 text-white font-medium px-8 py-4 rounded-md text-lg transition-colors"
        >
          Browse Upcoming Events
        </Link>
      </section>

      {/* Why Pop-Up Yoga */}
      <section className="bg-white py-20 px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl font-semibold text-center text-green-800 mb-12">Why Pop-Up Yoga?</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
            {[
              {
                icon: '🌿',
                title: 'Outdoor Practice',
                body: "Experience yoga in nature's embrace with fresh air and beautiful scenery",
              },
              {
                icon: '👥',
                title: 'Real Community',
                body: 'Practice is personal, but the path is shared. Meet teachers and students building a genuine local community',
              },
              {
                icon: '📍',
                title: 'Flexible Locations',
                body: 'We bring yoga to you — parks, beaches, rooftops, and unique venues',
              },
              {
                icon: '🔒',
                title: 'Privacy Respected',
                body: 'Your email and phone number are never shared with other users. We collect only what keeps the community safe',
              },
            ].map(({ icon, title, body }) => (
              <div
                key={title}
                className="text-center p-8 rounded-xl shadow-md hover:-translate-y-1 transition-transform"
              >
                <div className="text-4xl mb-4">{icon}</div>
                <h3 className="text-xl font-semibold text-green-800 mb-3">{title}</h3>
                <p className="text-gray-600">{body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA strip */}
      <section className="bg-green-800 text-white text-center py-16 px-4">
        <h2 className="text-3xl font-light mb-4">Ready to join us?</h2>
        <p className="text-lg mb-8 opacity-90">
          Finding and attending free events is always free. Create an account to register and stay notified.
        </p>
        <div className="flex justify-center gap-4 flex-wrap">
          <Link
            to="/auth"
            className="bg-white text-green-800 font-semibold px-8 py-3 rounded-md hover:bg-gray-100 transition-colors"
          >
            Sign Up Free
          </Link>
          <Link
            to="/about"
            className="border border-white text-white font-semibold px-8 py-3 rounded-md hover:bg-green-700 transition-colors"
          >
            Learn More
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white text-center py-8">
        <p className="text-gray-400 text-sm">&copy; {new Date().getFullYear()} Pop-Up Yoga. All rights reserved.</p>
        <p className="text-gray-500 text-xs mt-2">
          <Link to="/privacy" className="hover:text-gray-300 transition-colors">Privacy Policy</Link>
          {' · '}
          <Link to="/terms" className="hover:text-gray-300 transition-colors">Terms of Service</Link>
        </p>
      </footer>
    </div>
  );
};
